import { render, staticRenderFns } from "./ProSetting.vue?vue&type=template&id=7984e4c3&scoped=true"
import script from "./ProSetting.vue?vue&type=script&lang=js"
export * from "./ProSetting.vue?vue&type=script&lang=js"
import style0 from "./ProSetting.vue?vue&type=style&index=0&id=7984e4c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7984e4c3",
  null
  
)

export default component.exports